import { VideoFrame } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { Heading } from '@frontend/design-system';
import CollapsibleCard from '../../components/CollapsibleCard';
import { AddWidgetCard, DirectToWebPortal, TextConnectDiagram } from '../../components/TextConnect';
import { section, subHeaders } from './styles';

const videoUrl = 'https://weave.wistia.com/medias/9prvpgkr7l';

interface Props {
  locationId: string;
  showInstructionLink?: boolean;
}

export function SetupTextConnect({ locationId, showInstructionLink = true }: Props) {
  const { t } = useTranslation('schedule');

  return (
    <section css={section}>
      <VideoFrame title={t('Set up text connect')} src={videoUrl} />

      <TextConnectDiagram />

      <Heading level={2} css={subHeaders}>
        {t('How to Set Up Text Connect')}
      </Heading>

      <CollapsibleCard title={t('Method 1')} subTitle={t('Add a Widget To Your Website')} maxWidth={720}>
        <AddWidgetCard locationId={locationId || ''} showInstructionLink={showInstructionLink} />
      </CollapsibleCard>

      <CollapsibleCard title={t('Method 2')} subTitle={t('Direct Your Customers To A Web Portal')} maxWidth={720}>
        <DirectToWebPortal locationId={locationId || ''} />
      </CollapsibleCard>
    </section>
  );
}
